import React from 'react'
import './index.less'

const SvgIcon = props => (
  <svg className='icon_svg' viewBox='0 0 48 1' {...props}>
    <path d='M0 0h48v1H0z' fill='currentColor' fillRule='evenodd' />
  </svg>
)
const SvgSubscribe = props => (
  <svg className='icon_svg' viewBox='0 0 16 18' {...props}>
    <path
      d='M.97 0h14.06a.97.97 0 0 1 .97.97v16.06a.97.97 0 0 1-1.301.911L8.33 15.627a.97.97 0 0 0-.662 0L1.3 17.941A.97.97 0 0 1 0 17.03V.97A.97.97 0 0 1 .97 0zM14 15.617V2.001H2v13.616l5.337-1.94a1.94 1.94 0 0 1 1.326 0L14 15.618zM11.694 4.291l.012.011a.97.97 0 0 1 .023 1.37L8.174 9.355a.97.97 0 0 1-1.333.059l-2.516-2.18a.902.902 0 0 1-.037-1.33l.09-.088a.97.97 0 0 1 1.285-.057l1.873 1.515 2.777-2.95a.97.97 0 0 1 1.381-.032z'
      fill='#FFF'
      fillRule='nonzero'
      opacity={0.6}
    />
  </svg>
)
const SvgClient = props => (
  <svg className='icon_svg' viewBox='0 0 18 18' {...props}>
    <path
      d='M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-1.998A7.002 7.002 0 1 0 9 1.998a7.002 7.002 0 0 0 0 14.004zm-.45-3.497H6.83a.27.27 0 0 1-.191-.461l2.86-2.848a.27.27 0 0 0 0-.382l-2.86-2.848a.27.27 0 0 1 .19-.46h1.72a.27.27 0 0 1 .191.078l3.244 3.23a.27.27 0 0 1 0 .382l-3.244 3.23a.27.27 0 0 1-.19.08z'
      fillRule='nonzero'
      fill='#FFF'
      opacity={0.6}
    />
  </svg>
)
const SvgRecord = props => (
  <svg className='icon_svg' viewBox='0 0 18 18' {...props}>
    <path
      d='M9 9h3.016c.497 0 .978.514.978 1.011 0 .497-.481.992-.978.992H7.9a.9.9 0 0 1-.9-.9V5.891c0-.497.508-.905 1.005-.905.497 0 .994.408.994.905V9zm9 0a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9zm-2.002-.007c0-3.858-3.146-6.986-7.005-6.986a6.986 6.986 0 0 0-6.986 6.986c0 3.859 3.128 7.005 6.986 7.005 3.859 0 7.005-3.146 7.005-7.005z'
      fillRule='nonzero'
      fill='#FFF'
      opacity={0.6}
    />
  </svg>
)
const SvgUpload = props => (
  <svg className='icon_svg' viewBox='0 0 18 18' {...props}>
    <path
      d='M16.61 9.976h-3.805v7h-8v-7H1L8.805 1l7.805 8.976z'
      strokeWidth={2}
      stroke='#FFF'
      fill='none'
      fillRule='evenodd'
      opacity={0.6}
    />
  </svg>
)
const SvgVip = props => (
  <svg className='icon_svg' viewBox='0 0 18 16' {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M13.712 4.07L17.146.631A.5.5 0 0 1 18 .984V16H0V.984A.5.5 0 0 1 .854.631l3.434 3.44a.3.3 0 0 0 .424 0L8.646.13a.5.5 0 0 1 .708 0l3.934 3.94a.3.3 0 0 0 .424 0z'
        fill='#C1A875'
        fillRule='nonzero'
      />
      <path
        d='M8.792 10.932L6.088 8.333a.3.3 0 0 1 0-.432l.867-.833a.3.3 0 0 1 .415 0L9 8.634l1.63-1.566a.3.3 0 0 1 .415 0l.867.833a.3.3 0 0 1 0 .432l-2.704 2.599a.3.3 0 0 1-.416 0z'
        fill='#FFF'
      />
    </g>
  </svg>
)
export {
  SvgIcon,
  SvgSubscribe,
  SvgClient,
  SvgRecord,
  SvgUpload,
  SvgVip
}
